import { DateHelper } from '@helpers/date.helper';
import { BusinessUnit } from '@models/business-unit';
import { Contributor } from '@models/contributor';

export const WITHOUT_QUERY_PARAM_VALUE = 'without';

export function statusAtParam(statusAtParam: string): { startDate: string; endDate: string } {
  const data = { startDate: null, endDate: null };

  if (statusAtParam === WITHOUT_QUERY_PARAM_VALUE) {
    return data;
  }

  const splittedDate: string[] = statusAtParam.split(',');

  const startDate: string = splittedDate.find((date: string) => date.startsWith('>='));
  const endDate: string = splittedDate.find((date: string) => date.startsWith('<='));

  if (startDate) {
    data.startDate = DateHelper.format(startDate.slice(2));
  }

  if (endDate) {
    data.endDate = DateHelper.format(endDate.slice(2));
  }

  return data;
}

export function contributorsParam(contributorsParam: string): Contributor[] {
  if (contributorsParam === WITHOUT_QUERY_PARAM_VALUE) {
    return [];
  }

  return contributorsParam
    .split('|')
    .map((stringifyedContributor: string) => Contributor.fromJson(JSON.parse(stringifyedContributor)));
}

export function businessUnitsParam(businessUnitsParam: string): BusinessUnit[] {
  if (businessUnitsParam === WITHOUT_QUERY_PARAM_VALUE) {
    return [];
  }

  return businessUnitsParam
    .split('|')
    .map((stringifyedBusinessUnit: string) => BusinessUnit.fromJson(JSON.parse(stringifyedBusinessUnit)));
}
